import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWatchCircleFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 15.9998,
		cy: 16.0013,
		r: 13.8333,
		stroke: "#D9D9D9"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16 10.668C12.3636 10.668 9.25818 12.9298 8 16.1225C9.25818 19.3152 12.3636 21.5771 16 21.5771C19.6364 21.5771 22.7418 19.3152 24 16.1225C22.7418 12.9298 19.6364 10.668 16 10.668ZM16 13.9407C14.7927 13.9407 13.8182 14.9152 13.8182 16.1225C13.8182 17.3298 14.7927 18.3043 16 18.3043C17.2073 18.3043 18.1818 17.3298 18.1818 16.1225C18.1818 14.9152 17.2073 13.9407 16 13.9407Z",
		stroke: "#162395",
		strokeWidth: 1.5
	})]
});
export default SvgWatchCircleFilled;
